var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 213,
    viewBox: "0 0 195 213",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M194.824 140.565V72.1885C194.824 58.6035 187.58 46.0663 175.82 39.2737L116.602 5.09439C104.842 -1.69813 90.3534 -1.69813 78.5929 5.09439L19.3933 39.2737C7.63282 46.0663 0.388672 58.6035 0.388672 72.1885V140.565C0.388672 154.15 7.63282 166.688 19.3933 173.48L78.611 207.659C90.3714 214.452 104.86 214.452 116.62 207.659L175.82 173.48C187.58 166.688 194.824 154.132 194.824 140.565Z",
    fill: "url(#paint0_linear_3595_4495)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3595_4495",
    x1: 146.212,
    y1: 190.565,
    x2: 48.9963,
    y2: 22.1828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1537,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4791,
    stopColor: "#F8F8FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9365,
    stopColor: "#E6E6EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E3ED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector2);
export default __webpack_public_path__ + "static/media/vector2.683e5fb13350d45631e2c191694a68ed.svg";
export { ForwardRef as ReactComponent };